export default Object.freeze({
  Base: -1,
  FX: 1,
  IR: 2,
  AG: 3,
  Metal: 4,
  Energy: 5,
  Other: 6,
})
